
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Деректер көзі',
	'dataSourceId': 'Идентификатор',
	'dataSourceType': 'Түрі',
	'dataSourceName': 'Аты',
	'dataSourcePath': 'Жол',
	'showInfoForAll': 'Барлық көрнекілендірулер үшін ұзақтығын көрсетіңіз',
	'hideInfoForAll': 'Барлық көрнекілендірулер үшін ұзақтығын жасырыңыз',
	'showPerformanceDetails': 'Өнімділік туралы мәліметтерді қосу үшін барлық виджеттерді қайта қосыңыз',
	'slotMappingField': 'Карталарды кескіндеу',
	'slotDataMapping': 'Салыстыру',
	'slotID': 'ID',
	'slotCaption': 'Тақырып',
	'slotMandatory': 'Міндетті',
	'slotIsMandatory': 'Иә',
	'slotIsNotMandatory': 'Жоқ',
	'infoNotAvailable': 'Қол жетімді емес',
	'performanceSection': 'Өнімділік',
	'durationField': 'ұзақтық',
	'singleQueryTime': 'Сервер сұрауы (мс)',
	'multipleQueryTime': 'Сервер сұрауы %{name} (мс)',
	'liveWidgetTotalTime': 'Барлығы (мс)',
	'renderTimeNotAvailable': 'қол жетімді емес',
	'renderInProgress': '(орындалуда)',
	'interactToTriggerQuery': 'Сұрауды бастау үшін виджетпен өзара әрекеттесіңіз',
	'fetchQuery': 'Сұранысты алу',
	'showSQLMDX': 'SQL/MDX көрсету',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Сұрау ақпараты',
	'queryInfoNotAvailable': 'Сұрау туралы ақпарат қол жетімді емес',
	'query': 'Сұрау',
	'copy': 'Көшіру',
	'close': 'Жабу'
});
